import React from 'react';

class Loading extends React.Component {
  render() {
    return (
      <p>Carregando...</p>
    );
  }
}

export default Loading;
